export default "<app-loading-spinner></app-loading-spinner>"